const quickAbout = {
    status: 'AI Engineer @ Pentera',
    title: 'Tomer Halali',
    role: 'AI Engineer',
    description:
        'I build production LLM agents and RAG systems — and the AWS infrastructure that runs them. Multi-agent orchestration on LangGraph and Bedrock, retrieval at scale, and the LLM gateway, evals and Terraform underneath it all.',
    viewWork: 'View my work',
    resume: 'Download résumé',
    currently: 'Currently',
};

export default quickAbout;
